import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base.service';
import { lastValueFrom } from 'rxjs';
import { Contacto } from 'src/app/models/notificacion/contacto.model';


@Injectable({
  providedIn: 'root'
})
export class ContactoService extends BaseService {

    
    recordName = 'contactos';

    url = `${ environment.host }/contacto`;

    codigoModulo = Contacto.CODIGO_MODULO;
    codigoRegistro = Contacto.CODIGO_REGISTRO;

    async filtarContacto( body: Record<string, any>) {      
        let url = `${this.url}/filtrar-contacto`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  body , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
    
    async procesarContactos( body: Record<string, any>, filtros: string ) {      
        let url = `${this.url}/procesar-contacto`;
        try {
            await this.updateToken();
            const headers = this.header;
            headers['filtros'] = filtros;
            const resp = await lastValueFrom(this.http.post<any>(url,  body , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async filtrarNumeros( body: Record<string, any>) {      
        let url = `${this.url}/filtrar-numero`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  body , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async recuperarContactosMedalla( body: Record<string, any>) {      
        let url = `${this.url}/recuperar-contacto-medalla`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  body , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
}